import { api } from './client';
import type { SiteMeta } from '../utils/meta';

export interface FaqEntry {
  id: string;
  question: string;
  answer: string;
  /** Help-page group; null = uncategorised. */
  category: string | null;
  position: number;
}

export interface LegalPage {
  id: string;
  slug: string;
  title: string;
  content: string;
  updatedAt: string;
}

export interface SocialLink {
  id: string;
  platform: string;
  url: string;
}

export const fetchPublicFaq = () => api.get<FaqEntry[]>('/cms/faq').then(r => r.data);
export const fetchLegalPage = (slug: string) => api.get<LegalPage>(`/cms/legal/${slug}`).then(r => r.data);
export const fetchSocialLinks = () => api.get<SocialLink[]>('/cms/social-links').then(r => r.data);
export const fetchSiteMeta = () => api.get<SiteMeta>('/meta').then(r => r.data);
/** Which optional home-page sections the admin left on (CMS → Homepage). */
export const fetchHomepageSections = () => api.get<Record<string, boolean>>('/cms/homepage').then(r => r.data);
